module.exports = __webpack_public_path__ + "static/media/icn_ui_arrow_small_up.b6dfde1f.svg";